export default function AuthInvalid() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen px-4">
      <div className="text-center">
        <div className="text-6xl mb-4">&#128683;</div>
        <h1 className="text-3xl font-bold text-white mb-4">Invalid Link</h1>
        <p className="text-gray-400 max-w-md">
          This magic link is invalid. Please check your email for the correct
          link or contact the producer for a new one.
        </p>
      </div>
    </div>
  );
}
